import { Link } from 'react-router-dom';

const CLUSTER_STYLES = {
  dump_site: { color: '#dc2626', label: 'Dump Site' },
  perpetrator: { color: '#9333ea', label: 'Perpetrator Linked' },
  mp_cluster: { color: '#d97706', label: 'MP Group' },
  migrant_corridor: { color: '#0891b2', label: 'Migrant Corridor' },
};

const PRIORITY_COLOR = {
  critical: '#dc2626', high: '#f59e0b', medium: '#6b7280',
};

export function ClusterPanel({ cluster, onClose }) {
  if (!cluster) return null;
  const style = CLUSTER_STYLES[cluster.type] || CLUSTER_STYLES.dump_site;

  return (
    <div
      data-testid="cluster-panel"
      style={{
        position: 'absolute',
        top: 0, right: 0, bottom: 0,
        width: 340,
        background: '#0f0f1a',
        borderLeft: `1px solid ${style.color}33`,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'monospace',
        animation: 'clusterSlideIn 0.2s ease-out',
        overflowY: 'auto',
      }}
    >
      <style>{`
        @keyframes clusterSlideIn {
          from { transform: translateX(20px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .cluster-tooltip .leaflet-tooltip {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }
      `}</style>

      {/* Header */}
      <div style={{
        padding: '16px',
        borderBottom: `1px solid ${style.color}22`,
        background: `linear-gradient(135deg, ${style.color}11 0%, transparent 60%)`,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <span style={{
            display: 'inline-block',
            background: `${style.color}22`,
            border: `1px solid ${style.color}44`,
            borderRadius: 3,
            padding: '2px 8px',
            color: style.color,
            fontSize: 9,
            letterSpacing: 1.5,
            marginBottom: 8,
          }}>
            {style.label.toUpperCase()}
          </span>
          <button
            onClick={onClose}
            data-testid="cluster-panel-close"
            style={{
              background: 'none', border: 'none',
              color: '#666', cursor: 'pointer', fontSize: 20,
            }}
          >
            x
          </button>
        </div>

        <div style={{ color: '#f0f0f0', fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
          {cluster.name}
        </div>
        {cluster.subtitle && (
          <div style={{ color: '#888', fontSize: 11 }}>{cluster.subtitle}</div>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <div style={{
            flex: 1, textAlign: 'center', padding: '8px',
            background: '#1a1a2e', borderRadius: 4, border: '1px solid #333',
          }}>
            <div style={{ color: style.color, fontSize: 22, fontWeight: 700 }}>
              {cluster.count}
            </div>
            <div style={{ color: '#666', fontSize: 9, letterSpacing: 1 }}>CASES</div>
          </div>
          <div style={{
            flex: 1, textAlign: 'center', padding: '8px',
            background: '#1a1a2e', borderRadius: 4,
            border: `1px solid ${PRIORITY_COLOR[cluster.priority] || '#6b7280'}44`,
          }}>
            <div style={{
              color: PRIORITY_COLOR[cluster.priority] || '#6b7280',
              fontSize: 12, fontWeight: 700, textTransform: 'uppercase',
            }}>
              {cluster.priority}
            </div>
            <div style={{ color: '#666', fontSize: 9, letterSpacing: 1 }}>PRIORITY</div>
          </div>
        </div>
      </div>

      {/* Cases */}
      <div style={{ padding: '14px 16px', flex: 1 }}>
        <div style={{ color: '#555', fontSize: 9, letterSpacing: 1.5, marginBottom: 8 }}>
          LINKED CASES
        </div>
        {(cluster.cases || []).map((c, i) => (
          <Link
            key={i}
            to={`/case/${c.id || c}`}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '7px 10px', marginBottom: 4,
              background: '#1a1a2e', borderRadius: 4,
              borderLeft: `2px solid ${style.color}66`,
              textDecoration: 'none',
            }}
          >
            <span style={{ color: style.color, fontSize: 9 }}>
              {String(i + 1).padStart(2, '0')}
            </span>
            <span style={{ color: '#ccc', fontSize: 12 }}>{c.name || c.id || c}</span>
          </Link>
        ))}

        {cluster.investigator_note && (
          <div style={{ marginTop: 14 }}>
            <div style={{ color: '#555', fontSize: 9, letterSpacing: 1.5, marginBottom: 8 }}>
              INVESTIGATOR NOTE
            </div>
            <div style={{
              background: '#1a1a2e', border: '1px solid #2a2a3e',
              borderRadius: 4, padding: '10px',
              color: '#bbb', fontSize: 11, lineHeight: 1.6,
            }}>
              {cluster.investigator_note}
            </div>
          </div>
        )}
      </div>

      {/* CTA */}
      <div style={{ padding: '14px 16px', borderTop: '1px solid #1a1a2e' }}>
        {cluster.contact && (
          <>
            <div style={{ color: '#555', fontSize: 9, letterSpacing: 1.5, marginBottom: 6 }}>
              CONTACT
            </div>
            <div style={{ color: '#e0e0e0', fontSize: 12, marginBottom: 10 }}>
              {cluster.contact}
            </div>
          </>
        )}
        <Link
          to={`/potential-matches?cluster=${cluster.id}`}
          style={{
            display: 'block', width: '100%', padding: '10px',
            background: style.color, borderRadius: 4, textAlign: 'center',
            color: '#fff', fontSize: 11, fontWeight: 700,
            letterSpacing: 1, textDecoration: 'none',
            textTransform: 'uppercase',
          }}
        >
          View All Cases
        </Link>
      </div>
    </div>
  );
}
